import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=b5cbcb04&scoped=true&lang=pug"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cbcb04",
  null
  
)

export default component.exports